import { render, staticRenderFns } from "./loading-page.vue?vue&type=template&id=37aaed4a&scoped=true"
import script from "./loading-page.vue?vue&type=script&lang=js"
export * from "./loading-page.vue?vue&type=script&lang=js"
import style0 from "./loading-page.vue?vue&type=style&index=0&id=37aaed4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aaed4a",
  null
  
)

export default component.exports